// extracted by mini-css-extract-plugin
export default {"gradientText":"Card_gradientText__iyDig","gradientTextSecondary":"Card_gradientTextSecondary__PGZ2X","card":"Card_card__bep8a"};